<!--重出转寄-->
<template>
    <div class="resend-box">
           
        <div style="text-align:left;">
            <el-select v-model="storeIds" filterable style="margin-top:15px;margin-left:15px; margin-bottom:15px; width:calc(100% - 300px); max-width: calc(100% - 300px); min-width: 300px;" multiple :placeholder="msg('请选择')" size="mini">
                <el-option v-for="store in stores" :key="store.id" :label="store.name" :value="store.id"></el-option>
            </el-select>
            <el-button type="primary" size="mini" icon="el-icon-check" v-if="hasPermission('stock:autoResend')" @click="previewResend">{{msg('开始匹配')}}</el-button>
            <el-button type="success" size="mini" icon="el-icon-check" @click="getExpData">{{msg('手动选择')}}</el-button>
        </div>

        <h3 v-show="datas.length>0">{{msg('自动匹配的订单')}}</h3>
        <div v-if="datas.length>0" class="table-wrap">
            <vxe-table border resizable 
                    ref="dataTable"
                    size="mini" show-header-overflow
                    highlight-hover-row :max-height="height1"
                    class="mytable-style"
                    :cell-style="mytd"
                    :header-cell-style="myth"
                    :sort-config="{trigger: 'cell'}"
                    :span-method="mergeRowMethod"
                    :scroll-y="{gt: -1}"
                    :data="datas">
                <vxe-table-colgroup class="gropu0" :title="msg('待转寄订单')" :fixed="docWidth<950?'':'left'" field="group0" header-align="center">
                    <vxe-table-column  field="resendId" :title="msg('订单编号')" width="80" sortable>
                        <template v-slot="{ row }">
                            {{row.resendCode}}
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('标题')" show-overflow  field="resendTitle" min-width="120">
                    </vxe-table-column>
                    <vxe-table-column :title="msg('规格')" show-overflow field="resendSpec" min-width="100">
                        <template v-slot="{ row }">
                            <div>{{row.resendSpec}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('货号')" show-overflow  field="resendVariationSku" min-width="100">
                        <template v-slot="{ row }">
                            <div>{{row.resendVariationSku}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('SKU')" show-overflow  field="resendSku" min-width="100">
                        <template v-slot="{ row }">
                            <div>{{row.resendSku}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('采购单号')" show-overflow field="resendPurchaseCode" width="120"></vxe-table-column>
                    <vxe-table-column :title="msg('转寄单号')" show-overflow field="resendInventoryCode" width="120"></vxe-table-column>
                    <vxe-table-column :title="msg('件数')" field="resendQty" width="50" align="center"></vxe-table-column>
                </vxe-table-colgroup>
                <vxe-table-colgroup class="gropu1" :title="msg('现有库存')" field="group1" header-align="center">
                    <vxe-table-column :title="msg('件数(总/余)')" field="inventory.balanceQty" width="100" align="center">
                        <template v-slot="{ row }">
                            <div>{{row.inventory?(row.inventory.totalQty +"/"+row.inventory.balanceQty):""}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('库存单号')" show-overflow field="inventory.code" width="120"></vxe-table-column>
                    <vxe-table-column :title="msg('入仓时间')" show-overflow field="inventory.inStoreDate" width="80"></vxe-table-column>
                    <vxe-table-column :title="msg('标题')" show-overflow field="inventory.title" min-width="120">
                    </vxe-table-column>
                    <vxe-table-column :title="msg('规格')" show-overflow field="inventory.spec" min-width="100">
                        <template v-slot="{ row }">
                            <div>{{row.inventory? row.inventory.spec:""}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('货号')" show-overflow  field="inventory.variationSku" min-width="100">
                    </vxe-table-column>
                    <vxe-table-column :title="msg('SKU')" show-overflow  field="inventory.sku" min-width="100">
                    </vxe-table-column>
                    <vxe-table-column :title="msg('仓库')" show-overflow field="inventory.storeName" width="100">
                        <template v-slot="{ row }">
                            <div>{{row.inventory?(row.inventory.storeName?row.inventory.storeName:"默认仓库"):""}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('仓库类型')" field="inventory.storeType" width="70">
                        <template v-slot="{ row }">
                            <div>{{ getStoreType(row)}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('操作')" field="msg" width="70">
                         <template v-slot="{ row, rowIndex }">
                            <div>
                                <el-link v-if="hasPermission('stock:autoResendSearch')" 
                                    :type="(row.inventory || row.resendInventoryCode || row.purchaseStatus == 1)?'success':'danger'" 
                                    :icon="(row.inventory || row.resendInventoryCode || row.purchaseStatus == 1)?'el-icon-circle-check':'el-icon-circle-close'" 
                                    style="font-size:20px;" :underline="false">
                                </el-link>
                                <el-link  v-if="hasPermission('stock:autoResendSearch') && (row.resendType === null || row.resendType === 0)" 
                                    type="primary" icon="el-icon-search" 
                                    style="font-size:20px;padding-left:5px;" :underline="false" 
                                    @click="searchStock(row, rowIndex, 0)">
                                </el-link>
                            </div>
                        </template>
                    </vxe-table-column>
                </vxe-table-colgroup>
                <vxe-table-colgroup :title="msg('其他')" field="group2" header-align="center">
                    <vxe-table-column field="resendId1" show-overflow :title="msg('货单备注')" width="150">
                        <template v-slot="{ row, rowIndex}">
                            <div style="text-align:center;">
                                 {{row.resendRemark}}
                                <el-link type="primary" @click="editRemark(row, rowIndex, 0)" icon="el-icon-edit" style="font-size:18px;" :underline="false"></el-link>
                            </div>
                        </template>
                    </vxe-table-column>
                </vxe-table-colgroup>
                <vxe-table-colgroup :title="msg('操作')" field="group3" header-align="center" fixed='right' :show-overflow="false">
                    <vxe-table-column field="resendId3"  min-width="70" :title="msg('移除')" >
                        <template v-slot="{ row, rowIndex }">
                            <div>
                                <!--
                                <el-link v-if="showClear(row, 1)" type="warning" icon="el-icon-bottom" 
                                    style="font-size:20px;" :underline="false" 
                                    @click="moveToUnmatch(row, rowIndex, 0)" >
                                </el-link>
                                -->
                                <el-link type="danger" icon="el-icon-delete" style="font-size:20px;padding-left:5px;" 
                                    :underline="false"
                                     @click="removeRow(row, rowIndex, 0)">
                                </el-link>
                            </div>
                        </template>
                    </vxe-table-column>
                </vxe-table-colgroup>
            </vxe-table>
        </div>

        <h3 v-show="datas1.length>0">{{msg('需要手动匹配的订单')}}</h3>
        <div v-if="datas1.length>0" style="display:flex; justify-content: left; align-items:center;margin-left:10px;">
            <div>
                <el-button type="success" size="mini" icon="el-icon-serach" @click="searchMainStock">{{msg('整包单独转寄')}}</el-button>
                <el-button type="danger" size="mini" icon="el-icon-remove" @click="tableRemove">{{msg('批量移除')}}</el-button>
            </div>
        </div>
        <div v-if="datas1.length>0" class="table-wrap">
            <vxe-table border resizable 
                    ref="dataTable1"
                    size="mini" show-header-overflow
                    highlight-hover-row :max-height="height2"
                    class="mytable-style"
                    :cell-style="mytd"
                    :header-cell-style="myth"
                    :sort-config="{trigger: 'cell'}"
                    :scroll-y="{gt: -1}"
                    :span-method="mergeRowMethod"
                    @checkbox-change="changeData1Select"
                    :data="datas1">
                <vxe-table-colgroup class="gropu0" :title="msg('待转寄订单')" :fixed="docWidth<950?'':'left'" field="group0" header-align="center">
                    <vxe-table-column  type="checkbox" field="resendId" width="40">
                    </vxe-table-column>
                    <vxe-table-column  field="resendCode" :title="msg('订单编号')" width="80" sortable>
                        <template v-slot="{ row }">
                            {{row.resendCode}}
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('标题')" show-overflow  field="resendTitle" min-width="160">
                        <template v-slot="{ row }">
                            <div>{{row.resendTitle}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('规格')" show-overflow field="resendSpec" min-width="135">
                        <template v-slot="{ row }">
                            <div>{{row.resendSpec}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('货号')" show-overflow  field="resendVariationSku" min-width="100">
                        <template v-slot="{ row }">
                            <div>{{row.resendVariationSku}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('SKU')" show-overflow  field="resendSku" min-width="100">
                        <template v-slot="{ row }">
                            <div>{{row.resendSku}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('采购单号')" show-overflow field="resendPurchaseCode" width="120"></vxe-table-column>
                    <vxe-table-column :title="msg('转寄单号')" show-overflow field="resendInventoryCode" width="120"></vxe-table-column>
                    <vxe-table-column :title="msg('件数')" field="resendQty" width="50" align="center"></vxe-table-column>
                </vxe-table-colgroup>
                <vxe-table-colgroup class="gropu1" :title="msg('现有库存')" field="group1" header-align="center">
                    <vxe-table-column :title="msg('件数(总/余)')" field="inventory.balanceQty" width="100" align="center">
                        <template v-slot="{ row }">
                            <div>{{row.inventory? (row.inventory.totalQty +"/"+row.inventory.balanceQty):""}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('库存单号')" show-overflow field="inventory.code" width="120"></vxe-table-column>
                     <vxe-table-column :title="msg('入仓时间')" show-overflow field="inventory.inStoreDate" width="80"></vxe-table-column>
                    <vxe-table-column :title="msg('标题')" show-overflow field="inventory.title" min-width="200">
                    </vxe-table-column>
                    <vxe-table-column :title="msg('规格')" show-overflow field="inventory.spec" min-width="135">
                    </vxe-table-column>
                    <vxe-table-column :title="msg('货号')" show-overflow  field="inventory.variationSku" min-width="100">
                    </vxe-table-column>
                    <vxe-table-column :title="msg('SKU')" show-overflow  field="inventory.sku" min-width="100">
                    </vxe-table-column>
                    <vxe-table-column :title="msg('仓库')" show-overflow field="inventory.storeName" width="100">
                        <template v-slot="{ row }">
                            <div>{{row.inventory?(row.inventory.storeName?row.inventory.storeName:"默认仓库"):""}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('仓库类型')" field="inventory.storeType" width="70">
                        <template v-slot="{ row }">
                            <div>{{ getStoreType(row)}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('操作')" field="msg" width="70">
                        <template v-slot="{ row, rowIndex }">
                            <div>
                                <el-link v-if="hasPermission('stock:autoResendSearch')" 
                                    :type="(row.inventory || row.resendInventoryCode || row.purchaseStatus == 1)?'success':'danger'" 
                                    :icon="(row.inventory || row.resendInventoryCode || row.purchaseStatus == 1)?'el-icon-circle-check':'el-icon-circle-close'" 
                                    style="font-size:20px;" :underline="false">
                                </el-link>
                                <el-link v-if="hasPermission('stock:autoResendSearch') && (row.resendType === null || row.resendType === 0)" 
                                    type="primary" icon="el-icon-search" style="font-size:20px;padding-left:5px;" 
                                    :underline="false" @click="searchStock(row, rowIndex, 1)">
                                </el-link>
                            </div>
                        </template>
                    </vxe-table-column>
                </vxe-table-colgroup>
                <vxe-table-colgroup :title="msg('其他')" field="group2" header-align="center">
                    <vxe-table-column field="resendId1" show-overflow :title="msg('货单备注')" width="150">
                        <template v-slot="{ row, rowIndex }">
                            <div style="text-align:center;">
                                 {{row.resendRemark}}
                                <el-link type="primary" icon="el-icon-edit"  @click="editRemark(row, rowIndex, 1)" style="font-size:18px;" :underline="false"></el-link>
                            </div>
                        </template>
                    </vxe-table-column>
                </vxe-table-colgroup>
                <vxe-table-colgroup :title="msg('操作')" field="group3" header-align="center" fixed='right' >
                    <vxe-table-column field="resendId3"  min-width="70" :title="msg('操作')" >
                        <template v-slot="{ row, rowIndex }">
                            <div>
                                <el-link  type="warning" 
                                    icon="el-icon-refresh-right" style="font-size:20px;" :underline="false" 
                                    @click="clearMatch(row, rowIndex)" >
                                </el-link>
                                <el-link type="danger" icon="el-icon-delete" style="font-size:20px;padding-left:5px;" 
                                    :underline="false" @click="removeRow(row, rowIndex, 1)">
                                </el-link>
                            </div>
                        </template>
                    </vxe-table-column>
                </vxe-table-colgroup>
            </vxe-table>
        </div>

        <h3 v-show="datas1.length>0">{{msg('不能匹配的订单')}}</h3>
        <div v-if="errDatas.length>0" class="table-wrap" style="margin-top:5px;">
            <vxe-table border resizable 
                    size="mini" show-header-overflow
                    highlight-hover-row :max-height="height3"
                    :span-method="mergeRowMethod"
                    :scroll-y="{gt: -1}"
                    :data="errDatas">
                <!-- <vxe-table-colgroup class="gropu0" :title="msg('不能匹配的数据')" :fixed="isMinScreen?'':'left'" field="group0" header-align="center"> -->
                    <vxe-table-column  field="resendId" :title="msg('订单编号')" width="120" sortable>
                        <template v-slot="{ row }">
                            {{row.resendCode}}
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('标题')" show-overflow  field="resendTitle" min-width="200">
                        <template v-slot="{ row }">
                            <div>{{row.resendTitle}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('规格')" show-overflow field="resendSpec" min-width="135">
                        <template v-slot="{ row }">
                            <div>{{row.resendSpec}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('货号')" show-overflow field="resendVariationSku" min-width="100">
                        <template v-slot="{ row }">
                            <div>{{row.resendVariationSku}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('SKU')" show-overflow field="resendSku" min-width="100">
                        <template v-slot="{ row }">
                            <div>{{row.resendSku}}</div>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :title="msg('件数')" field="resendQty" width="50"></vxe-table-column>
                    <vxe-table-column :title="msg('原因')" show-overflow field="msg" min-width="135">
                        <template v-slot="{ row }">
                            <div>{{row.msg}}</div>
                        </template>
                    </vxe-table-column>
                <!-- </vxe-table-colgroup> -->
            </vxe-table>
        </div>

        <div style="margin: 20px; text-align:center; ">
            <el-button type="primary" size="mini" icon="el-icon-check" @click="prepareResend(1)">{{msg('保存当前所有匹配结果')}}</el-button>
            <el-button style="margin-left:50px;" type="success" size="mini" icon="el-icon-check" @click="prepareResend(2)">{{msg('提交已全部匹配完成的订单')}}</el-button>
        </div>

        <el-dialog :title="msg('查找库存')" :visible.sync="visible" :fullscreen="isMinScreen"  @opened="openedSearch"
            :close-on-click-modal="false" 
                width="1100px">
            <stock-search :stores="stores" :useds="useds" :resend="selectedResend" :type="selectType" :detailId="detailId"
                 ref="searchDg" v-on:close-dg="closeSearch"/>
        </el-dialog>

        <el-dialog :title="msg('请选择首发仓库')" :visible.sync="selectStoreVisible" :fullscreen="isMinScreen" 
            :close-on-click-modal="false" width="500px">
            <div>
                <div>存在多个仓库，请选择首发仓库</div>
                <el-select v-model="firstStore" style="margin-top:15px; margin-bottom:15px; width:100%;" :placeholder="msg('请选择')" size="mini">
                    <el-option v-for="store in stores" :key="store.id" :label="store.name" :value="store.id"></el-option>
                </el-select>
                <div style="margin: 20px; text-align:center; ">
                    <el-button size="mini" icon="el-icon-close" @click="() => selectStoreVisible = false">{{msg('取消')}}</el-button>
                    <el-button type="primary" size="mini" icon="el-icon-check" @click="enterSelectFirstStore()">{{msg('确定')}}</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import XEUtils from 'xe-utils';
import StockSearch from './StockMatchSearch.vue';
export default {
    components:{
        StockSearch: StockSearch,
    },
    mounted(){
        this.selectedResend = null;
        this.selectedIndex = null;
        this.selectType = null;
        this.datas = [];
        this.datas1 = [];
        this.errDatas = [];
        this.useds = [];
        this.storeIds = [];
        this.ids = this.$route.params.ids;
        this.submitOk = false;
        this.getStores();
    },
    watch:{
      $route(){
        let routeName = this.$route.name;
        if(routeName == "stockMatch"){
            //跳转到该页面后需要进行的操作
            let newIds= this.$route.params.ids;
            // console.log(this.$route)
            if(newIds){
                if(this.ids){
                    if(newIds.sort().join(",")!=this.ids.sort().join(",")){
                        this.selectedResend = null;
                        this.selectedIndex = null;
                        this.selectType = null;
                        this.datas = [];
                        this.datas1 = [];
                        this.errDatas = [];
                        this.useds = [];
                        this.storeIds = [];
                        this.ids = this.$route.params.ids;
                        this.submitOk = false;
                        this.getStores();

                        this.selectStoreVisible = false;
                        this.firstStore = null;
                        this.submitType = 2; //1-提交所有匹配结果，2-仅提交全部匹配完成的订单
                    }
                }else{
                    this.ids =  newIds;
                }

               
            }
        }

       
      }
    },
    data(){
        return{
            //当前选中的行
            selectedResend: null,
            //当前选中的行索引
            selectedIndex: null,
            selectType: null, //0-表示datas选择，1-datas1中选择, 2: 选中整条库存

            visible: false,
            
            ids: null, //待转寄的inventory id列表
            storeIds: [],

            stores: [], //可选仓库列表
            useds: [], //正在被使用的库存
            //匹配成功
            datas: [],
            //需要手动匹配的数据
            datas1: [],
            errDatas: [],
            //非法的数据
            submitOk: false,
            height1: 600,
            height2: 600,
            height3: 600,
            detailId:null,

            selectStoreVisible: false,
            firstStore: null,  //首发仓库id
            submitType : 2, //1-提交所有匹配结果，2-仅提交全部匹配完成的订单
            resendCrossStores: null //夸仓数据的数据记录
        }
    },
    computed: {
        docWidth: {  //是否小屏幕，浏览器
            get() {
                var width = this.$store.state.docWidth;
                return width;
            }
        },
        isMinScreen:{
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
        routeTab: {
            get(){
                try{
                    return this.$store.state.activeMenus[this.$route.path]
                }catch{
                    return null;
                }
            }
        }
    },
    methods:{
        mergeRowMethod({ row, _rowIndex, column, visibleData }){
            const fields = ['resendCode','resendId','resendId1','resendId2','resendId3'];
            if(!column.property || !visibleData){
                return { rowspan: 0, colspan: 0 }
            }
            const cellValue = XEUtils.get(row, column.property)
            if (cellValue && fields.includes(column.property)) {
                const prevRow = visibleData[_rowIndex - 1]
                let nextRow = visibleData[_rowIndex + 1]
                if (prevRow && XEUtils.get(prevRow, column.property) === cellValue) {
                    return { rowspan: 0, colspan: 0 }
                } else {
                    let countRowspan = 1
                    while (nextRow && XEUtils.get(nextRow, column.property) === cellValue) {
                        nextRow = visibleData[++countRowspan + _rowIndex]
                    }
                    if (countRowspan > 1) {
                        return { rowspan: countRowspan, colspan: 1 }
                    }
                }
            }
        },
        getStoreType(row){
            if(!row.inventory || !row.inventory.storeType){
                return "";
            }

            let storeType = this.dicts.stockStoreType.find(e => e.value == row.inventory.storeType);
            // console.log(storeType);
            if(storeType){
                return storeType.label;
            }
            return row.store.storeType;
        },
        getStores(){
            this.$axios.post(this.$kit.api.store.listUsed, {})
                .then( (result) => {
                    if(result.status){
                        let data = result.data;
                        data.splice(0, 0, {id: 0, name: '默认仓库'});
                        this.stores = data;
                    }
                });
        },
        //执行自动匹配，并得到自动匹配结果
        previewResend(){
            if(!this.ids || this.ids.length == 0){
                this.$message("没有选择要匹配的订单");
                return;
            }

            if(this.storeIds.length == 0){
                this.$message("提示：请先选择要匹配哪个仓库的库存");
                return;
            }

            this.$axios.post(this.$kit.api.resend.preview, 
                    "ids="+this.ids.join(",")+"&storeIds="+(this.storeIds?this.storeIds.join(","):"0"), 
                    {headers: {'Content-Type' : 'application/x-www-form-urlencoded'}})
                .then( (result) => {
                    if(result.status){
                        let success = result.data.success;
                        let fails = result.data.fails;
                        let useds = result.data.useds;
                        let illegals = result.data.illegals;

                        success.forEach(s => {
                            s.resendId1 = s.resendId2 = s.resendId3 = s.resendId;

                            if(s.inventory){
                                let used = useds.find(u => u.inventoryId == s.inventory.inventoryId);
                                if(used){
                                    s.inventory = used;
                                }else{
                                    useds.push(s.inventory);
                                }
                            }

                        });

                        fails.forEach(s => {
                            s.resendId1 = s.resendId2 = s.resendId3 = s.resendId;
                            if(s.inventory){
                                if(s.inventory.inventoryId){
                                    let used = useds.find(u => u.inventoryId == s.inventory.inventoryId);
                                    if(used){
                                        s.inventory = used;
                                    }else{
                                        useds.push(s.inventory);
                                    }
                                }else{
                                    s.inventory = null;
                                }
                               
                            }
                        });

                        if(success.length>0){
                            let height = (success.length * 40 + 80);
                            if(height>800){
                                height = 800;
                            }

                            if(height<450){
                                height =450;
                            }

                            this.height1 = height;
                        }

                        if(fails.length>0){
                            let height = (fails.length * 40 + 80);
                            if(height>800){
                                height = 800;
                            }

                            if(height<450){
                                height =450;
                            }

                            this.height2 = height;
                        } 

                        if(illegals.length>0){
                            let height = (illegals.length * 40 + 80);
                            if(height>800){
                                height = 800;
                            }

                            if(height<450){
                                height = 450;
                            }

                            this.height3 = height;
                        }

                        this.datas = success;
                        this.datas1 = fails;
                        this.useds = useds;
                        this.errDatas = illegals;

                    }else{
                        this.$message(result.msg);  
                    }
                });
        },
        //判断需不需要显示清空按钮，这个主要取决于这里面的数据，之前是否存在过转寄
        // showClear(row, type){
        //     let ds = type === 0?this.datas : this.datas1;
        //     let same= ds.filter(s => s.resendId == row.resendId && s.resendType>0);
        //     return (same && same.length>0)?false:true;
        // },
        getExpData(){
            if(!this.ids || this.ids.length == 0){
                this.$message("没有要匹配的数据");
                return;
            }

            this.$axios.post(this.$kit.api.resend.findExps, 
                    "ids="+this.ids.join(","), 
                    {headers: {'Content-Type' : 'application/x-www-form-urlencoded'}})
                .then( (result) => {
                    if(result.status){
                        let fails = result.data.fails;
                        let illegals = result.data.illegals;

                        fails.forEach(s => {
                            s.resendId1 = s.resendId2 = s.resendId3 = s.resendId;
                        });

                        if(fails.length>0){
                            let height = (fails.length * 40 + 80);
                            if(height>800){
                                height = 800;
                            }

                            if(height<450){
                                height =450;
                            }

                            this.height2 = height;
                        } 

                        if(illegals.length>0){
                            let height = (illegals.length * 40 + 80);
                            if(height>800){
                                height = 800;
                            }

                            if(height<450){
                                height =450;
                            }

                            this.height3 = height;
                        }

                        this.datas1 = fails;
                        this.errDatas = illegals;

                    }else{
                        this.$message(result.msg);  
                    }
                });

        },

        //删除选中数据
        removeRow(row, rowIndex, type){
            this.confirmCtrl(this.msg('确定要取消转寄吗？'), ()=>{
                let ds = type === 0?this.datas : this.datas1;
                //ds.splice(rowIndex, 1);
                //先找到所有数据，然后还原数量
                let dels = ds.filter(d => d.resendId == row.resendId);
                dels.forEach(d => {

                    //还原数量，
                    if(d.inventory){
                        d.inventory.balanceQty += d.resendQty; 
                    }

                    //删除数据
                    let idx = ds.findIndex(d1 => d1.resendId == d.resendId && d1.resendDetailId == d.resendDetailId);
                    if(idx >- 1){
                        ds.splice(idx, 1);
                    }

                });
            });
        },
        tableRemove(){//批量移除
            var selectes = this.$refs.dataTable1.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中数据进行操作'));
                return;
            }
            selectes.forEach(select => {
                let code = select.resendCode;

                this.datas1 = this.datas1.filter(d => {
                    
                    let result = d.resendCode != code;
                    if(!result){
                        if(d.inventory){
                            d.inventory.balanceQty += d.resendQty;
                        }
                    }

                    return  result;
                });
            })
        },
        
        //将已经匹配好的移动到未匹配好的列表中，同时移除库存
        moveToUnmatch(row, index){
            this.confirmCtrl(this.msg('确定手动匹配该数据吗？'), ()=>{
                //找出这条数据的所有数据
                let inventorys = this.datas.filter(d => d.resendId == row.resendId);
                //找出所有主数据
                let mainStocks = inventorys.filter(d => d.resendInventoryCode);
                
                //移除库存
                inventorys.forEach(s => {
                    if(s.resendType == 0){
                        s.inventory.balanceQty += s.resendQty;
                        s.inventory = null;
                        s.resendMatched="";
                        s.resendInventoryCode = null;
                        s.resendInventoryId = null;
                        s.shelfCode = null;
                        s.storeId = null;
                        s.inStoreCode = null;
                        s.pkgType = null;
                    }
                     //删除数据
                    let idx = this.datas.findIndex(d1 => d1.resendId == s.resendId);
                    if(idx >- 1){
                        this.datas.splice(idx, 1);
                    }
                });

                //将子数据合并到主数据
                inventorys.forEach(s => {
                    if(s.resendParentDetailId){
                        let mainStock = mainStocks.find(m => m.resendDetailId == s.resendParentDetailId);
                        if(mainStock){
                            mainStock.resendQty += s.resendQty;
                        }
                    }
                });

                //解决诡异的问题，单只有一条数据自动转寄成功时，并且移动到手动转寄时
                if(this.datas.length==0){
                    this.datas = [{}];
                    setTimeout(()=>{
                        this.datas = [];
                    }, 2000);
                }

                //移动到未匹配中
                mainStocks.forEach(m => {
                    ////解决诡异的问题，单只有一条数据自动转寄成功时，并且移动到手动转寄时
                    let m1 = {};
                    for(let key in m){
                        if(key != '_XID'){
                            m1[key]=m[key];
                        }
                    }
                    this.datas1.push(m1);
                });

            });

        },
        clearMatch(row, rowIndex){
            this.confirmCtrl(this.msg('确定要清空已匹配的数据吗？'), ()=>{
                //找出这条数据的所有数据
                let inventorys = this.datas1.filter(d => d.resendId == row.resendId);

                inventorys = inventorys.filter( d => d.resendType == null || d.resendType == 0);
                //移除库存
                inventorys.forEach(s => {

                    if(s.origin === 0){
                        if(s.inventory){
                            s.inventory.balanceQty += s.resendQty;
                        }
                    }else{
                        if(s.inventory){
                            let usedIdx = this.useds.findIndex(u => u.inventoryId == s.inventory.inventoryId);
                            if(usedIdx>-1){
                                this.useds.splice(usedIdx,1);
                            }
                        }
                    }

                    s.inventory = null;
                    s.resendMatched="";
                    s.resendInventoryCode = null;
                    s.resendInventoryId = null;
                    s.shelfCode = null;
                    s.storeId = null;
                    s.inStoreCode = null;
                    s.pkgType = null;
                    s.resendType = null;
                });

                //找出所有主数据
                let mainStocks = inventorys.filter(d => d.resendDetailId);

                //将子数据合并到主数据
                inventorys.forEach(s => {
                    if(s.resendParentDetailId){
                        let mainStock = mainStocks.find(m => m.resendDetailId == s.resendParentDetailId);
                        if(mainStock){
                            mainStock.resendQty += s.resendQty;
                        }
                    }
                });


                //找出子数据，并删除
                let removes = inventorys.filter(d => d.resendParentDetailId);
                removes.forEach(s => {
                    //删除数据
                    let idx = this.datas1.findIndex(d1 => d1.resendId == s.resendId && d1.resendParentDetailId == s.resendParentDetailId);
                    if(idx >- 1){
                        this.datas1.splice(idx, 1);
                    }

                });
            });
        },

        confirmCtrl(text, cb){
            this.$confirm(this.msg(text), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
               cb();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消操作'
                });          
            });
        },

        //搜索库存
        searchStock(row, rowIndex, type){
            this.detailId = row.resendDetailId;
            this.selectedResend = row;
            this.selectedIndex = rowIndex;
            this.selectType = type;
            this.visible = true;
        },

        //打开搜索弹窗之后
        openedSearch(){
            this.$nextTick(()=>{
                this.$refs.searchDg.init();
            });
        },
        //按条搜索库存
        searchMainStock(){
            var selectes = this.$refs.dataTable1.getCheckboxRecords();
            if(selectes.length==0 || selectes.length>1){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            //判断选中的数据是不是存在已经匹配的
            let select = selectes[0];
            let resends = this.datas1.filter(s => s.resendId == select.resendId);
            for(let i = 0; i<resends.length; i++){
                let resend = resends[i];
                if(resend.resendType > 0){
                    this.$message(this.msg('提示：请先清空采购或转寄再执行该操作'));
                    return;
                }
            }

            this.selectedResend = selectes[0];



            this.selectType = 2;
            this.visible = true;
        },
        //关闭弹窗选择数据
        closeSearch(selectes,type){
            // console.log("type:",type);
            //如果选中的不为空，说明选了库存，将待匹配的数据和库存关联起来
            if(selectes){
                if(this.selectType == 2){
                    //这里是整包转寄
                    
                    //查到所有待转寄数据
                    let exps = this.datas1.filter(s => s.resendId == this.selectedResend.resendId);
                    if(exps.length>0){
                        
                        let inventory = selectes[0];

                        let newused1 = {
                            balanceQty: 0,
                            code: inventory.code,
                            inventoryId: inventory.id,
                            storeId: inventory.storeId,
                            storeName: inventory.storeName, 
                            storeType: inventory.storeType,
                            totalQty: inventory.productQty,
                            shelfCode: inventory.shelfCode,
                            inStoreCode: inventory.inStoreCode,
                            inStoreDate: inventory.inStoreTime,
                            status: inventory.status,
                            searchType: type,
                            spec: inventory.spec,
                            title: inventory.title,
                            sku: inventory.titleSku,
                            variationSku: inventory.variationSku
                        };

                        exps.forEach(e => {
                            e.resendMatched="成功";
                            e.resendInventoryCode = inventory.code;
                            e.resendInventoryId = inventory.id;
                            e.shelfCode = inventory.shelfCode;
                            e.storeId = inventory.storeId;
                            e.inStoreCode = inventory.inStoreCode || inventory.code;
                            e.inventory = newused1;
                            e.origin = 1;
                            e.resendType = 0;
                        });

                        this.useds.push(newused1);

                        for(let i=1; i<selectes.length; i++){
                            
                            let select = selectes[i];
                            if(select){
                                let newused = {
                                    balanceQty: 0,
                                    code: select.code,
                                    inventoryId: select.id,
                                    storeId: select.storeId,
                                    storeName: select.storeName, 
                                    storeType: select.storeType,
                                    totalQty: select.productQty,
                                    shelfCode: select.shelfCode,
                                    inStoreCode: select.inStoreCode,
                                    inStoreDate: select.inStoreTime,
                                    status: select.status,
                                    searchType: type,
                                    spec: select.spec,
                                    title: select.title,
                                    sku: select.titleSku,
                                    variationSku: select.variationSku 
                                };
                                this.useds.push(newused);
                            }

                        }
                       
                        this.visible = false;
                    }
                }else{
                    // 待匹配数量
                    let qty = this.selectedResend.resendQty;
                    //如果之前匹配过，则恢复数量
                    let preused = this.selectedResend.inventory;
                    if(preused){
                        preused.balanceQty += qty;
                    }

                    //开始匹配
                    let index = 0;
                    for(let i=0; i<selectes.length; i++){

                        if(qty<=0){
                            break;
                        }

                        let inventory = selectes[i];

                        //let used = this.useds.find(u => u.stockDetailId == stock.detailId);
                        
                        //库存数量
                        let stockQty = inventory.balanceQty;
                        //需要的数量
                        let needQty = 0;
                        //库存剩余的数量
                        let balanceQty = 0;

                        //sotck数据返回的时候，已经将剩余的关联起来了
                        if(inventory.used){
                            stockQty = inventory.used.balanceQty;
                        }
                        if(stockQty<1){
                            continue;
                        }

                        if(stockQty >= qty) {
                            needQty = qty;
                            balanceQty = stockQty - qty;
                            qty = 0;
                        }else {
                            needQty = stockQty;
                            qty = qty - stockQty;
                            balanceQty = 0;
                        }

                        //修改原数据
                        if(index == 0){
                            this.selectedResend.resendMatched="成功";
                            this.selectedResend.resendQty = needQty;
                            this.selectedResend.resendInventoryCode = inventory.code;
                            this.selectedResend.resendInventoryId = inventory.id;
                            this.selectedResend.shelfCode = inventory.shelfCode;
                            this.selectedResend.storeId = inventory.storeId;
                            this.selectedResend.origin = 0;
                            this.selectedResend.inStoreCode = inventory.inStoreCode || inventory.code;
                            this.selectedResend.resendType = 0;

                            //如果已经选中的数据已经在之前选择过，则只更新数量
                            if(inventory.used){
                                inventory.used.balanceQty = balanceQty;
                                this.selectedResend.inventory = inventory.used;
                            }else{
                                //如果已经选中的数据之前没有选择过，则新增一条
                                let newused = {
                                    balanceQty: balanceQty,
                                    code: inventory.code,
                                    inventoryId: inventory.id,
                                    storeId: inventory.storeId,
                                    storeName: inventory.storeName, 
                                    storeType: inventory.storeType,
                                    totalQty: inventory.productQty,
                                    shelfCode: inventory.shelfCode,
                                    inStoreCode: inventory.inStoreCode,
                                    inStoreDate: inventory.inStoreTime,
                                    status: inventory.status,
                                    searchType: type,
                                    spec: inventory.spec,
                                    title: inventory.title,
                                    sku: inventory.titleSku,
                                    variationSku: inventory.variationSku 
                                };
                                this.selectedResend.inventory = newused;
                                this.useds.push(newused);
                            }

                        }else{
                            let newresend = {
                                resendCode:this.selectedResend.resendCode,
                                resendId: this.selectedResend.resendId,
                                resendMatched:"成功",
                                resendParentDetailId:this.selectedResend.resendDetailId || this.selectedResend.resendParentDetailId,
                                resendQty:needQty,
                                resendRemark:this.selectedResend.remark2,
                                resendSpec:this.selectedResend.resendSpec,
                                resendVariationSku:this.selectedResend.resendVariationSku,
                                resendSku:this.selectedResend.resendSku,
                                resendInventoryCode:inventory.code,
                                resendInventoryId:inventory.id,
                                owner:this.selectedResend.owner,
                                productId:this.selectedResend.productId,
                                productName:this.selectedResend.productName,
                                productPrice:this.selectedResend.productPrice,
                                resendTitle:this.selectedResend.resendTitle,
                                shelfCode: inventory.shelfCode,
                                inStoreCode: inventory.inStoreCode || inventory.code,
                                storeId: inventory.storeId,
                                inventory: null,
                                origin: 0,
                                resendType: 0
                            }

                            newresend.resendId1 = newresend.resendId2 = newresend.resendId3 = newresend.resendId; 

                            if(inventory.used){
                                inventory.used.balanceQty = balanceQty;
                                newresend.inventory = inventory.used;
                            }else{
                                let newused = {
                                    balanceQty: balanceQty,
                                    code: inventory.code,
                                    inventoryId: inventory.id,
                                    storeId: inventory.storeId,
                                    storeName: inventory.storeName, 
                                    storeType: inventory.storeType,
                                    totalQty: inventory.productQty,
                                    shelfCode: inventory.shelfCode,
                                    inStoreCode: inventory.inStoreCode,
                                    inStoreDate: inventory.inStoreTime,
                                    status: inventory.status,
                                    searchType: type,
                                    spec: inventory.spec,
                                    title: inventory.title,
                                    sku: inventory.titleSku,
                                    variationSku: inventory.variationSku 
                                };
                                newresend.inventory = newused;
                                this.useds.push(newused);
                            }

                            if(this.selectType === 0){
                                this.datas.splice(this.selectedIndex+index+1,0,newresend);
                            }else if(this.selectType == 1){
                                this.datas1.splice(this.selectedIndex+index+1,0,newresend);
                            }

                        }

                        index ++;
                    }
                    
                    //如果匹配选择的数据匹配完了，qty还有，则生成一条新的
                    if(qty>0 && index>0){
                        let newresend = JSON.parse(JSON.stringify(this.selectedResend));
                        if(!newresend.resendParentDetailId){
                            newresend.resendParentDetailId = newresend.resendDetailId;
                        }

                        newresend.resendDetailId =null;
                        newresend.resendInventoryId = null;
                        newresend.resendInventoryCode = null;
                        newresend.resendQty = qty;
                        newresend.inventory = null;
                        newresend.resendType = null;

                        if(this.selectType === 0){
                            this.datas.splice(this.selectedIndex+1,0,newresend);
                        }else if(this.selectType == 1){
                            this.datas1.splice(this.selectedIndex+1,0,newresend);
                        }
                    }
                    // console.log(this.datas1);
                    // console.log(this.useds);
                    // console.log(this);
                    // this.$refs.dataTable.reloadData(this.datas);
                    // this.$refs.dataTable1.reloadData(this.datas1);
                    this.visible = false;
                }
            }else{
                this.$message(this.msg("请选择库存"));
            }
        },
        //type:1-提交所有匹配结果，2-仅提交全部匹配完成的订单
        prepareResend(type){
            // console.log(1111);
            this.submitType = type;

            if(this.submitOk){
                this.$message({
                    type: 'danger',
                    message: this.msg('提示：匹配结果已提交，无需重复提交！')
                });
                return;
            }

            this.$confirm(this.msg('确定要提交匹配结果吗？'), this.msg('提示'), {
                    confirmButtonText: this.msg('确定'),
                    cancelButtonText: this.msg('取消'),
                    type: 'warning'
                }).then(() => {
                    try{
                        this.checkAndSubmitResend();
                    }catch(err){
                        console.log(err);
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.msg('取消')
                    });          
            });
        },

        //type:1-提交所有匹配结果，2-仅提交全部匹配完成的订单
        checkAndSubmitResend(){
            // let resendMap = this.mapOfKeyResendId(this.datas);
            // let resendMap1 = this.mapOfKeyResendId(this.datas1);

            // if(this.submitType == 2){
            //     //判断是否存在没有匹配的
            //     let isAll = this.existPartOfMatch(resendMap);
            //     if(isAll){
            //         isAll = this.existPartOfMatch(resendMap1);
            //         if(!isAll){
            //             this.$message({
            //                 type: 'danger',
            //                 message: this.msg('请先将未全部匹配上库存的订单移除')
            //             });  
            //             return;
            //         }
            //     }else{
            //         this.$message({
            //             type: 'danger',
            //             message: this.msg('请先将未全部匹配上库存的订单移除')
            //         }); 
            //         return;
            //     }
            // }

            //不用选择首发仓库
            // this.resendCrossStores = [];
            // this.isSameStore(resendMap);
            // //判断是否要选择首发仓库
            // if(!this.resendCrossStores || this.resendCrossStores.length == 0){
            //     this.isSameStore(resendMap1);
            // }

            // if(this.resendCrossStores && this.resendCrossStores.length>0){
            //     this.firstStore = null;
            //     this.selectStoreVisible = true;
            // }else{
            //     this.doResend();
            // }
            this.doResend();

        },
        //判断一条记录里面的数据是否都转寄了
        existPartOfMatch(resendMap){
            let isAll = true;
            for(let resendId in resendMap){
                let arr = resendMap[resendId];
                let filtered = arr.filter(a => a.resendInventoryCode);
                if(arr.length > filtered.length){
                    isAll = false;
                    break;
                }
            }
            return isAll;
        },
        //判断一条记录里面的多条详情的转寄是否存在不同仓库
        isSameStore(resendMap){
            console.log(111);
            let isSelect = false;
            for(let resendId in resendMap){
                let resends = resendMap[resendId];
                
                let isSame = true;
                let existStoreStock = resends.find(s => s.storeId || s.storeId === 0);
                let prevStore = null;
                if(!existStoreStock){
                    console.log(222);
                    existStoreStock = resends.find(s => s.inventory && (s.inventory.storeId || s.inventory.storeId === 0));
                    if(existStoreStock){
                        prevStore = existStoreStock.inventory.storeId;
                    }
                    
                }else{
                    console.log(333);
                    prevStore = existStoreStock.storeId;
                }

                if(prevStore || prevStore === 0){
                    for(let i = 0; i<resends.length; i++){
                        let resend = resends[i];
                        if(resend.resendInventoryCode && resend.storeId !== prevStore){
                            isSame = false;
                            break;
                        }
                    }
                }else{
                    isSame = false;
                }

                if(!isSame){
                    this.resendCrossStores = [...this.resendCrossStores, ...resends]
                }

            }
            return isSelect;
        },
        mapOfKeyResendId(datas){
            let resendMap = {};
            datas.forEach(e => {
                let resendId = e.resendId;
                let arr = resendMap[resendId];
                if(!arr){
                    arr = [];
                    resendMap[resendId] = arr;
                }
                arr.push(e);
            });
            return resendMap;
        },

        //确定选择了首发仓库后，执行提交
        enterSelectFirstStore(){
            if(this.firstStore){
                this.selectStoreVisible = false;
                //设置仓库
                this.resendCrossStores.forEach(s => {
                    s.storeId = this.firstStore;
                    s.pkgType = 31;
                })

                this.doResend();
            }
        },
        //获取一条订单里面任意一条匹配了转寄的
        getAnyMatchedData(resendMap){
            let rows = [];

            for(let resendId in resendMap){
                let resends = resendMap[resendId];
                let isAnyMatch = false;
                for(let i = 0; i<resends.length; i++){
                    let resend = resends[i];
                    if(resend.resendType === 0 && resend.resendInventoryId){
                        isAnyMatch = true;
                    }
                }
                if(isAnyMatch){
                    rows = [...rows, ...resends];
                }
            }
            return rows;
        },
        //获取一条订单里面所有的详情都转寄了的
        getAllMatchedData(resendMap){
            let rows = [];
            for(let resendId in resendMap){
                let resends = resendMap[resendId];
                let isAll = true;
                for(let i = 0; i<resends.length; i++){
                    let resend = resends[i];
                    if(!resend.resendInventoryCode && resend.purchaseStatus==0){
                        isAll = false;
                        break;
                    }
                }
                if(isAll){
                    rows = [...rows, ...resends];
                }else{ //没有提交的删除匹配数据
                    resends.forEach(resend => {
                        let inv = resend.inventory;
                        if(inv){
                            inv.balanceQty = inv.balanceQty + resend.resendQty;
                        }
                        delete resend.inventory;
                    });
                }
            }
            return rows;
        },
        //保存转寄数据
        doResend(){
            let resends = [];

            //判断每一条数据是否都转寄
            //type:1-提交所有匹配结果，2-仅提交全部匹配完成的订单

             //先把数据按主数据分组，然后判断所有的待转寄的订单是否有转寄，如果都没有则过滤，只要有一条存在都可以转寄
            let resendMap = this.mapOfKeyResendId(this.datas);
            let resendMap1 = this.mapOfKeyResendId(this.datas1);

            if(this.submitType ==1 ){
                let datas = this.getAnyMatchedData(resendMap);
                let datas1 = this.getAnyMatchedData(resendMap1);
                resends = [...datas, ...datas1]
            }else{
                //这里存在同一个库存，给了多个地方匹配上了，但是由于有些事部分匹配的，但是没有提交，所以需要还原数量
                
                let datas = this.getAllMatchedData(resendMap);
                let datas1 = this.getAllMatchedData(resendMap1);
                resends = [...datas, ...datas1]
            }

            if(resends.length == 0){
                this.$message({
                    type: 'warning',
                    message: this.msg('没有要转寄的数据')
                });  
                return ;
            }

            this.$axios.post(this.$kit.api.resend.save+'?selectType='+this.selectType, resends)
                .then( (result) => {
                    this.$message(result.msg);
                    if(result.status){
                        this.submitOk = true;
                    }else{

                        if(result.data){
                            //表示库存不足，
                            let temps = result.data;
                            let dbStock = [];
                            // {id: qty} =>{id: "", qty:""}
                            for(let key in temps){
                                dbStock.push({
                                    id: key,
                                    qty: temps[key]
                                });
                            }
                            //移除关联，恢复库存数量
                            dbStock.forEach(bs => {
                                this.datas.forEach(d => {
                                    if(d.resendType == 0 && d.inventory && d.inventory.inventoryId ==  bs.id){
                                        d.inventory = null;
                                        d.resendInventoryId = null;
                                        d.resendInventoryCode = null;
                                    }
                                });
                                this.datas1.forEach(d => {
                                    if(d.resendType == 0 && d.inventory && d.inventory.inventoryId ==  bs.id){
                                        d.inventory = null;
                                        d.resendInventoryId = null;
                                        d.resendInventoryCode = null;
                                    }
                                });
                                
                                let idx = this.useds.findIndex(u => u.inventoryId == bs.id);
                                if(idx > -1){
                                    this.useds.splice(idx, 1);
                                }
                            });
                        }
                    }
                });
        },
        //编辑货单备注
        editRemark(row, rowIndex, type){
            this.$prompt(this.fmt('编辑%s的货单备注', [row.resendCode]), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
            }).then(({ value }) => {

                let ds = type == 1?this.datas1 : this.datas;
                let selecteds = ds.filter(d => d.resendId == row.resendId);
                selecteds.forEach(d => {
                    d.resendRemark = value;
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });  
            });
        },
        //点击checkbox
        changeData1Select({row, checked}){
            // console.log(row, checked);

            //将合并后的其他行也设置为不选中
            if(!checked){
                let {tableData} = this.$refs.dataTable1.getTableData();
                
                let rows = [];
                tableData.forEach(e => {
                    if(e.resendId == row.resendId){
                        rows.push(e);
                    }
                });

                this.$refs.dataTable1.setCheckboxRow(rows, false);
            }
        },

        //设置表格样式
        mytd({ row, rowIndex, column, columnIndex }){
            if(['resendId','resendTitle','resendSpec','resendSku','resendVariationSku', 'resendQty', 'resendInventoryCode'].indexOf(column.property)>-1){
                return {
                    borderTop: "1px solid rgba(0,0,0,0.7)",
                    borderLeft: "1px solid rgba(0,0,0,0.7)",
                    backgroundColor:"rgba(120,188,248,0.1)"
                }
            }else if(['stockQty','code', 'spec', 'title', 'storeName','storeType', 'msg'].indexOf(column.property)>-1){
                return {
                    borderTop: "1px solid rgba(0,0,0,0.7)",
                    borderLeft: "1px solid rgba(0,0,0,0.7)",
                    backgroundColor:"rgba(239,166,127,0.1)"
                }
            }else{
                return {
                    borderTop: "1px solid rgba(0,0,0,0.7)",
                    borderLeft: "1px solid rgba(0,0,0,0.7)",
                    backgroundColor:"rgba(174,255,139,0.1)"
                }
            }
        },
        myth({ column, columnIndex }){
            if(["group0",'group1','group2', 'group3'].indexOf(column.property)>-1){
                return {
                    borderTop: "1px solid rgba(0,0,0,0.7)",
                    borderLeft: "1px solid rgba(0,0,0,0.7)",
                    borderRight: column.property=='group2'?"1px solid rgba(0,0,0,0.7)":'',
                    backgroundColor:"rgba(217,217,217,1)"
                }
            }else if(['resendId','resendTitle','resendSpec','resendSku','resendVariationSku', 'resendQty', 'resendInventoryCode'].indexOf(column.property)>-1){
                return {
                    borderTop: "1px solid rgba(0,0,0,0.7)",
                    borderLeft: "1px solid rgba(0,0,0,0.7)",
                    backgroundColor:"rgba(120,188,248,0.1)"
                }
            }else if(['stockQty','code', 'spec', 'title', 'storeName','storeType', 'msg'].indexOf(column.property)>-1){
                return {
                    borderTop: "1px solid rgba(0,0,0,0.7)",
                    borderLeft: "1px solid rgba(0,0,0,0.7)",
                    backgroundColor:"rgba(239,166,127,0.1)"
                }
            }else{
                return {
                    borderTop: "1px solid rgba(0,0,0,0.7)",
                    borderLeft: "1px solid rgba(0,0,0,0.7)",
                    backgroundColor:"rgba(174,255,139,0.1)"
                }
            }
           
        }

        //end 设置表格样式

    }

}
</script>

<style lang="scss" scoped>
    .resend-box h2{padding-left: 15px; font-size:20px; color: rgba(100,100,100,0.9)}
    .resend-box h3{padding-left: 15px; font-size:16px; color: rgba(100,100,100,0.9)}
    .mytable-style{
        border: 1px solid rgba(0,0,0,0.7) !important;
    }

    .xmain .router-tab-page{
        height: calc(100vh - 100px);
    }
</style>